import { render, staticRenderFns } from "./lazy-image.vue?vue&type=template&id=48b5ea41&"
import script from "./lazy-image.vue?vue&type=script&lang=js&"
export * from "./lazy-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports